import { render, staticRenderFns } from "./supplementDetail.vue?vue&type=template&id=5df59a64&scoped=true"
import script from "./supplementDetail.vue?vue&type=script&lang=ts"
export * from "./supplementDetail.vue?vue&type=script&lang=ts"
import style0 from "./supplementDetail.vue?vue&type=style&index=0&id=5df59a64&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5df59a64",
  null
  
)

export default component.exports